import React, { FC, useCallback } from 'react';
import getClassName from 'src/common/utils/getClassName';
import { logoutThunk } from 'src/common/ducks/user';
import useAppDispatch from 'src/common/hooks/useAppDispatch';
import { homepageRedirect } from 'src/common/utils/routing';
import Icon from '../IconDS22';
import s from './Navigation.module.scss';

const LogoutNavItem: FC = () => {
  const dispatch = useAppDispatch();

  const logout = useCallback(async () => {
    const redirectToHome = await dispatch(logoutThunk());
    if (redirectToHome) {
      homepageRedirect();
    }
  }, [dispatch]);

  return (
    <button
      onClick={logout}
      className={getClassName(s, 'link', 'button nestedMenu')}
      type="button"
    >
      <Icon
        id="logout"
        size="m"
      />
      Sign Out
    </button>
  );
};

export default LogoutNavItem;
